export default __webpack_public_path__ + "static/media/admission05.aa39d797.jpg";